/* Prerequisites on page: 
 * 1. figshare js library
 * 2. id="articlefulltext_figshare" mount at expected location
 */
var SCM = SCM || {};

(function (ns, $) {
    ns.init = function () {
        var $figshareMount = $('#articlefulltext_figshare');

        if ($figshareMount.length) {
            var doi = $('meta[name="citation_doi"]').attr('content');

            if (doi) {
                var $fulltextWidget = $('.widget-ArticleFulltext');
                if ($fulltextWidget.length) {
                    ns.initMount($fulltextWidget, $figshareMount);
                    ns.loadFigShare(doi, $figshareMount);
                }
            }
        }
    };

    ns.loadFigShare = function (doi, $figshareMount) {
        figshare.load($figshareMount.data('widgetname'), function (FilesViewerWidget) {            
            var widget = new FilesViewerWidget({
                version: '3',
                width: $figshareMount.width(),
                showStats: $figshareMount.data('showstats').toLowerCase() === 'true',
                showPageInfo: $figshareMount.data('showpageinfo').toLowerCase() === 'true',
                showShareButton: $figshareMount.data('showsharebutton').toLowerCase() === 'true',
                showFileDetails: $figshareMount.data('showfiledetails').toLowerCase() === 'true',
                [$figshareMount.data('loaddoisbycollection').toLowerCase() === 'true' ? 'collection' : 'item']: { resourceDOI: doi }
            });
            
            widget.on('loading', function () {
                /* Use MutationObserver to detect when figshare content loads.
                 * This is more efficient than polling and reacts immediately when content appears.
                 */
                var observer = new MutationObserver(function() {
                    var $widget = $figshareMount.find('figshare-widget');
                    if ($widget.length && $widget.html() && $widget.html().trim().length) {
                        observer.disconnect(); // Stop observing

                        // Class can be used to apply styling to the figshare widget. Adding styling to an empty widget can cause problems.
                        $figshareMount.addClass('hascontent');

                        // make sure supplements tab is shown.
                        var $supplementsTab = $('.js-splitview-aside').find('[class*=supplement]');
                        if ($supplementsTab.length) {
                            // add hasContent flag so that it won't be removed/hidden by other concurrency events from splitscreen.js
                            $supplementsTab.addClass('js-hascontent');
                            $supplementsTab.show();
                        }

                        // Dispatch custom event to notify other components
                        $(document).trigger('figshare:contentLoaded', [$figshareMount]);
                    }
                });

                // Start observing once the figshare-widget element exists
                var checkForWidget = setInterval(function() {
                    var target = $figshareMount.find('figshare-widget')[0];
                    if (target) {
                        clearInterval(checkForWidget);
                        observer.observe(target, {
                            childList: true,
                            subtree: true,
                            characterData: true
                        });

                        // Safety timeout fallback (5 seconds)
                        setTimeout(function() {
                            observer.disconnect();
                        }, 5000);
                    }
                }, 100);

                // Cleanup if widget element never appears (after 3 seconds)
                setTimeout(function() {
                    clearInterval(checkForWidget);
                }, 3000);
            });

            widget.initialize();
            widget.mount($figshareMount[0]);
        });

    };

    ns.initMount = function ($fulltextWidget, $figshareMount) {
        // try to find SplitView tab first
        var $tabPane;
        var $supplementsTab;
        var $supplementsPanel;
        var $supplementsWrapper;

        $tabPane = $fulltextWidget.closest('.widget-SplitView').find('.js-splitview-aside');

        if ($tabPane.length) {
            $supplementsTab = $tabPane.find('[class*=supplement]');
            $supplementsPanel = $tabPane.find('.dynamic-widget-inner-wrap[role="tabpanel"]').has('div[class*=supplement]');
            $supplementsWrapper = $supplementsPanel.find('.widget-dynamic-inner-wrap');
        }

        if ($supplementsWrapper && $supplementsWrapper.length) {
            /* Can't mount $figshareMount to the hidden $supplementsPanel yet,
             * otherwise it won't get a proper width and do lazy loading properly.
             * Workaround is to hide figshare offscreen and only mount it when panel is shown.
             */
            var mountWidth = $tabPane.find('*[role="tabpanel"][aria-hidden="false"]').width();
            if (mountWidth) {
                var $positionContainer = $('<div class="position:relative"></div>').appendTo('body');
                $figshareMount.css({
                    position: 'absolute',
                    top: -9999,
                    left: -9999,
                    width: mountWidth
                })
                    .detach()
                    .appendTo($positionContainer);

                // supplement panel is displayed
                $supplementsTab.on('click', function () {
                    if ($figshareMount.parent('.widget-dynamic-inner-wrap').length === 0) {
                        $figshareMount.detach()
                            .prependTo($supplementsWrapper[0])
                            .css({
                                position: 'static',
                                top: 0,
                                left: 0
                            });
                    }
                });
            }
        }
        else {
            // check to see if it should be inserted in front of supplements first, then
            // try to insert in front of reference section. Otherwise left at the end of the fulltext
            var $location = $fulltextWidget.find('.backreferences-title');
            if ($('#ShowFigShareInDataSupplements').val()?.toLowerCase() === 'true') {
                $location = $('.article-body').find('.dataSuppLink:first');
            }
            
            if ($location.length === 1) {
                $figshareMount.detach().insertBefore($location);
            }
        }
    };
})(SCM.FigShare = SCM.FigShare || {}, jQuery);

$(function () {
    SCM.FigShare.init();
});